"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_2e4arxybaa = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/CurrentUserOrganizations.js";
  var hash = "71c8d20dca7282c995a6e25f986334bf06aaf0e7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/organizations/CurrentUserOrganizations.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 18
        },
        end: {
          line: 16,
          column: 3
        }
      },
      "1": {
        start: {
          line: 11,
          column: 36
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "2": {
        start: {
          line: 27,
          column: 18
        },
        end: {
          line: 27,
          column: 29
        }
      },
      "3": {
        start: {
          line: 28,
          column: 44
        },
        end: {
          line: 28,
          column: 56
        }
      },
      "4": {
        start: {
          line: 29,
          column: 18
        },
        end: {
          line: 37,
          column: 22
        }
      },
      "5": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "6": {
        start: {
          line: 31,
          column: 23
        },
        end: {
          line: 31,
          column: 82
        }
      },
      "7": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      "8": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "9": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 43,
          column: 32
        }
      },
      "10": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "11": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 16
        }
      },
      "12": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 58,
          column: 4
        }
      },
      "13": {
        start: {
          line: 61,
          column: 0
        },
        end: {
          line: 88,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 29
          },
          end: {
            line: 11,
            column: 30
          }
        },
        loc: {
          start: {
            line: 11,
            column: 36
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "CurrentUserOrganizations",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 33
          }
        },
        loc: {
          start: {
            line: 26,
            column: 3
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 30
          },
          end: {
            line: 29,
            column: 31
          }
        },
        loc: {
          start: {
            line: 29,
            column: 42
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 39,
            column: 13
          }
        },
        loc: {
          start: {
            line: 39,
            column: 18
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 39
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 12
          },
          end: {
            line: 25,
            column: 8
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 8
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 23,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 23,
            column: 19
          },
          end: {
            line: 23,
            column: 37
          }
        }],
        line: 23
      },
      "2": {
        loc: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 75
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 75
          }
        }],
        line: 24
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 22
          }
        }, {
          start: {
            line: 30,
            column: 26
          },
          end: {
            line: 30,
            column: 47
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }, {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }],
        line: 33
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 58,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 53,
            column: 11
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 57,
            column: 13
          }
        }],
        line: 44
      },
      "8": {
        loc: {
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 10
          },
          end: {
            line: 44,
            column: 24
          }
        }, {
          start: {
            line: 44,
            column: 29
          },
          end: {
            line: 44,
            column: 41
          }
        }, {
          start: {
            line: 44,
            column: 45
          },
          end: {
            line: 44,
            column: 65
          }
        }],
        line: 44
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "71c8d20dca7282c995a6e25f986334bf06aaf0e7"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _ = require("../");

var _core2 = require("../../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var useStyles = (cov_2e4arxybaa.s[0]++, (0, _styles.makeStyles)(function () {
  cov_2e4arxybaa.f[0]++;
  cov_2e4arxybaa.s[1]++;
  return {
    root: {
      overflow: 'auto',
      height: '100%'
    }
  };
}));

function CurrentUserOrganizations(_ref) {
  var onOrganization = _ref.onOrganization,
      authentication = _ref.authentication,
      organization = _ref.organization,
      _ref$messages = _ref.messages;
  _ref$messages = _ref$messages === void 0 ? (cov_2e4arxybaa.b[0][0]++, {}) : _ref$messages;
  var _ref$messages$primary = _ref$messages.primaryError,
      primaryError = _ref$messages$primary === void 0 ? (cov_2e4arxybaa.b[1][0]++, 'No Organizations') : _ref$messages$primary,
      _ref$messages$seconda = _ref$messages.secondaryError,
      secondaryError = _ref$messages$seconda === void 0 ? (cov_2e4arxybaa.b[2][0]++, 'You are not currently a member of any organizations.') : _ref$messages$seconda;
  cov_2e4arxybaa.f[1]++;
  var classes = (cov_2e4arxybaa.s[2]++, useStyles());

  var _ref2 = (cov_2e4arxybaa.s[3]++, (0, _react.useState)([])),
      _ref3 = _slicedToArray(_ref2, 2),
      organizations = _ref3[0],
      setOrganizations = _ref3[1];

  var getData = (cov_2e4arxybaa.s[4]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var userOrgs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_2e4arxybaa.f[2]++;
            cov_2e4arxybaa.s[5]++;

            if (!((cov_2e4arxybaa.b[4][0]++, authentication) && (cov_2e4arxybaa.b[4][1]++, authentication.config))) {
              _context.next = 12;
              break;
            }

            cov_2e4arxybaa.b[3][0]++;
            cov_2e4arxybaa.s[6]++;
            _context.next = 7;
            return (0, _core2.getCurrentUserOrgs)({
              config: authentication.config
            });

          case 7:
            userOrgs = _context.sent;
            cov_2e4arxybaa.s[7]++;

            if (userOrgs) {
              cov_2e4arxybaa.b[5][0]++;
              cov_2e4arxybaa.s[8]++;
              setOrganizations(userOrgs);
            } else {
              cov_2e4arxybaa.b[5][1]++;
            }

            _context.next = 13;
            break;

          case 12:
            cov_2e4arxybaa.b[3][1]++;

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [authentication]));
  cov_2e4arxybaa.s[9]++;
  (0, _react.useEffect)(function () {
    cov_2e4arxybaa.f[3]++;
    cov_2e4arxybaa.s[10]++;

    if (authentication) {
      cov_2e4arxybaa.b[6][0]++;
      cov_2e4arxybaa.s[11]++;
      getData();
    } else {
      cov_2e4arxybaa.b[6][1]++;
    }
  }, [authentication, getData]);
  cov_2e4arxybaa.s[12]++;
  return (cov_2e4arxybaa.b[8][0]++, authentication) && ((cov_2e4arxybaa.b[8][1]++, organization) || (cov_2e4arxybaa.b[8][2]++, organizations.length)) ? (cov_2e4arxybaa.b[7][0]++, /*#__PURE__*/_react.default.createElement(_core.List, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_.Organizations, {
    organization: organization,
    organizations: organizations,
    onOrganization: onOrganization,
    config: authentication.config,
    messages: {
      primaryError: primaryError,
      secondaryError: secondaryError
    }
  }))) : (cov_2e4arxybaa.b[7][1]++, /*#__PURE__*/_react.default.createElement("center", null, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null)));
}

cov_2e4arxybaa.s[13]++;
CurrentUserOrganizations.propTypes = {
  /** Pass a previously returned authentication object to bypass login. */
  authentication: _propTypes.default.shape({
    user: _propTypes.default.object.isRequired,
    token: _propTypes.default.object.isRequired,
    config: _propTypes.default.object.isRequired,
    remember: _propTypes.default.bool
  }).isRequired,

  /** The currently selected organization */
  organization: _propTypes.default.shape({
    avatar_url: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    full_name: _propTypes.default.string.isRequired,
    id: _propTypes.default.number.isRequired,
    location: _propTypes.default.string.isRequired,
    username: _propTypes.default.string.isRequired,
    visibility: _propTypes.default.string.isRequired,
    website: _propTypes.default.string.isRequired
  }),

  /** Function to call when organization is selected. */
  onOrganization: _propTypes.default.func.isRequired,

  /** Configuration required if paths are provided as URL. */
  config: _propTypes.default.shape({
    server: _propTypes.default.string.isRequired
  }),
  messages: _propTypes.default.shape({
    primaryError: _propTypes.default.string,
    secondaryError: _propTypes.default.string
  })
};
var _default = CurrentUserOrganizations;
exports.default = _default;